function richTextToPlainText(value) {
  if (!value) return "";
  if (typeof value === "number") return String(value);
  if (typeof value === "string") return value;
  if (Array.isArray(value)) {
    return value.map(richTextToPlainText).filter(Boolean).join("\n");
  }
  if (typeof value === "object") {
    if (value.type === "text") return value.text || "";
    if (Array.isArray(value.children)) {
      return value.children.map(richTextToPlainText).filter(Boolean).join("");
    }
    if (value.props?.children) {
      return richTextToPlainText(value.props.children);
    }
  }
  return "";
}

function htmlToPlainText(value) {
  return value
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/li>/gi, "\n")
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/&quot;/g, "\"")
    .replace(/&#39;/g, "'")
    .replace(/\s+\n/g, "\n")
    .replace(/\n\s+/g, "\n")
    .replace(/[ \t]{2,}/g, " ")
    .trim();
}

export function normalizeFaqItem(item) {
  if (!item) return null;

  const source = item.attributes || item;
  const question =
    source.Question ||
    source.question ||
    source.Title ||
    source.title ||
    source.name ||
    "";
  const answer =
    source.Answer ||
    source.answer ||
    source.Content ||
    source.content ||
    source.text ||
    "";

  const plainQuestion = richTextToPlainText(question).trim();
  const plainAnswer = htmlToPlainText(richTextToPlainText(answer));

  if (!plainQuestion || !plainAnswer) return null;

  return {
    question: plainQuestion,
    answer: plainAnswer,
  };
}

export function buildFaqSchema(items = []) {
  const faqs = items.map(normalizeFaqItem).filter(Boolean);

  if (faqs.length === 0) return null;

  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  };
}

export function stringifyJsonLd(data) {
  return JSON.stringify(data).replace(/</g, "\\u003c");
}
